export const ROUTES = {
  AUTH: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD_OTP: "/auth/reset-password-otp",
    RESET_PASSWORD_NEW: "/auth/reset-password-new",
    CONFIRM: "/auth/confirm",
    GOOGLE_CALLBACK: "/auth/google/callback",
    GITHUB_CALLBACK: "/auth/github/callback",
  },
  INVITE: "/invite/:token",
  DASHBOARD: {
    EDITOR: {
      QUERY_EDITOR: "/editor/query",
    },
    SETTINGS: {
      INDEX: "/settings",
      GENERAL: "/settings/general",
      TEAM: "/settings/team",
      CREDITS: "/settings/credits",
      BILLING: "/settings/billing",
      DEVELOPER: "/settings/developer",
    },
    STUDIO: {
      INDEX: "/chat",
      LIST: "/chat/list",
      THREAD: (threadId: string) => `/chat/${threadId}`,
    },
    RESOURCES: {
      INDEX: "/resources",
      CREATE: "/resources/create",
      CONFIGURE: (id: string) => `/resources/${id}/configure`,
      MANAGE: (id: string) => `/resources/${id}/manage`,
      MANAGE_CONTAINER: (id: string, containerId: string) => `/resources/${id}/manage/${containerId}`,
      SETTINGS: (id: string) => `/resources/${id}/settings`,
    },
    PLAYGROUND: "/playground",
    BOARDS: {
      LIST: "/boards",
      DETAIL: (id: string) => `/boards/${id}`,
      WIDGET: (boardId: string, widgetId: string) => `/boards/${boardId}/widget/${widgetId}`,
    },
    INTEGRATIONS: {
      INDEX: "/integrations",
      ADD: "/integrations/add",
      SLACK_CALLBACK: "/integrations/slack/callback",
      MANAGE: (type: string) => `/integrations/${type}`,
    },
    ORGANIZATION: {
      INDEX: "/organization",
      CREATE: "/organization/create",
      JOIN: "/organization/join",
    },
  },
}
